var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(11385 3597)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-11383 -3596.333)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.188 2.353)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M463.484,531.176h-5.59a3.585,3.585,0,0,1-3.58-3.581v-8.936a3.584,3.584,0,0,1,3.58-3.581h5.59a3.585,3.585,0,0,1,3.581,3.581V527.6A3.585,3.585,0,0,1,463.484,531.176Zm-5.59-15.034a2.521,2.521,0,0,0-2.518,2.518V527.6a2.521,2.521,0,0,0,2.518,2.518h5.59A2.521,2.521,0,0,0,466,527.6v-8.936a2.521,2.521,0,0,0-2.518-2.518Z",
    transform: "translate(-454.314 -515.079)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M446.1,523.343a3.793,3.793,0,0,1-3.788-3.788v-9.546a3.792,3.792,0,0,1,3.788-3.788h5.971a3.816,3.816,0,0,1,3.631,2.71.531.531,0,1,1-1.018.3,2.747,2.747,0,0,0-2.613-1.951H446.1a2.729,2.729,0,0,0-2.726,2.725v9.546a2.729,2.729,0,0,0,2.726,2.726.531.531,0,0,1,0,1.063Z",
    transform: "translate(-442.314 -506.221)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.578 5.122)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M466.714,526.566h-2.869a.531.531,0,1,1,0-1.063h2.869a.531.531,0,0,1,0,1.063Z",
    transform: "translate(-463.314 -525.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.578 7.336)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.018,534.9h-7.172a.531.531,0,1,1,0-1.063h7.172a.531.531,0,1,1,0,1.063Z",
    transform: "translate(-463.314 -533.836)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.578 9.549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.018,543.232h-7.172a.531.531,0,1,1,0-1.062h7.172a.531.531,0,1,1,0,1.063Z",
    transform: "translate(-463.314 -542.169)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.578 11.763)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M471.018,551.566h-7.172a.531.531,0,0,1,0-1.063h7.172a.531.531,0,0,1,0,1.063Z",
    transform: "translate(-463.314 -550.503)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(11.688 14.154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M486.845,563.487a.531.531,0,0,1-.531-.531v-2.922a.531.531,0,0,1,.531-.531h2.922a.531.531,0,1,1,0,1.063h-2.391v2.391A.531.531,0,0,1,486.845,563.487Z",
    transform: "translate(-486.314 -559.503)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.c5953d4db04e69fcab480b0967287472.svg";
export { ForwardRef as ReactComponent };